import { render, staticRenderFns } from "./AlteraPedidoVenda.vue?vue&type=template&id=9dedb378&scoped=true&"
import script from "./AlteraPedidoVenda.vue?vue&type=script&lang=js&"
export * from "./AlteraPedidoVenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dedb378",
  null
  
)

export default component.exports